import {Component, EventEmitter, Input, Output} from "@angular/core";
import {BsModalRef} from "ngx-bootstrap/modal";
import {ILocaleProperties, LocaleType} from "./locale-models";

@Component({
    selector: 'locale-switcher',
    templateUrl: './locale-switcher.component.html',
    styleUrls: ['./locale-switcher.component.scss'],
    standalone: false
})
export class LocaleSwitcherComponent {

    search: string;
    @Input() localeType: LocaleType;
    @Output() readonly updatedLocaleData = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
    ) {}

    cancel() {
        this.bsModalRef.hide();
    }

    onLocaleChange(locale: ILocaleProperties) {
        this.updatedLocaleData.emit(locale);
        this.bsModalRef.hide();
    }
}
